import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";
import { mutate } from "swr";
import { CheckboxIcon, PencilIcon, SettingsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

import {
    store as generalSettingStore,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setKey,
} from "./store";
import { store } from "@components/VerticalLayout/store";
import { useFetchGlobal } from "../../../api/hooks";
import { RedisPublishFoodCourt } from "./helpers";
import ErrorToast from "@components/Common/ErrorTost";
import { useSelector } from "react-redux";

type CustomIconsType = {
    e: any;
    setRowData: Function;
    setIsAddFoodCourtClicked: Function;
    setLocalFilterActive: Function;
    setIsModalOpened: Function;
};

export function CustomIcons({
    e,
    setRowData,
    setIsAddFoodCourtClicked,
    setLocalFilterActive,
    setIsModalOpened,
}: CustomIconsType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    let paymentType = useSelector((state: any) => state.global.paymentType);

    const { shopID } = useSnapshot(store);
    const { isActionsClicked, isEdited } = useSnapshot(generalSettingStore);

    async function handleOpenClose() {
        toast.dismiss();
        if (e.selectedRow.status === false && e.selectedRow.state !== true) {
            ErrorToast(
                t(
                    "Warning, you cannot activate a Food Court shop that does not have a published menu."
                )
            );
        } else if (
            e.selectedRow[t("Middleware IP address")] === "" &&
            e.selectedRow.state !== true
        ) {
            ErrorToast(
                t(
                    "Warning, you must enter the IP address to activate the Foodcourt store."
                )
            );
        } else if (
            e.selectedRow.state !== true &&
            paymentType === 2 &&
            (e.selectedRow.softaveraPay_Yavin.public_account_id === "" ||
                e.selectedRow.softaveraPay_Yavin.apiKey === "" ||
                e.selectedRow.softaveraPay_Yavin.yavinId === "")
        ) {
            ErrorToast(
                t(
                    "Warning, you must fill in all SoftaveraPay fields to activate the Food Court shop."
                )
            );
        } else {
            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/foodCourt`;
            let data = {
                shopId: shopID,
                data: {
                    [e.selectedRow.Id]: {
                        etat: !e.selectedRow.state,
                        horaires: e.selectedRow.hour,
                        remarque: e.selectedRow[t("Remark")],
                        middlewareIpAddress:
                            e.selectedRow[t("Middleware IP address")],
                        softaveraPay_Yavin: e.selectedRow.softaveraPay_Yavin,
                    },
                },
            };

            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            };
            try {
                const response: any = await fetchGlobal(
                    apiUrlAdd,
                    requestOptions
                );
                if (response.error) {
                    throw Error("error");
                }
                mutate(apiUrlAdd, response);
                setKey(uuid());
                setIsAddFoodCourtClicked(false);
                toast.success(
                    `${
                        e.selectedRow.state
                            ? t("Food court deactivated successfully")
                            : t("Food court activated successfully")
                    }`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                await RedisPublishFoodCourt(shopID, t, fetchGlobal);
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    return (
        <React.Fragment>
            <div className="d-flex justify-content-around">
                <Tooltip title={t("To modify")}>
                    <div>
                        <PencilIcon
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setRowData(e.selectedRow);
                                        setIsAddFoodCourtClicked(true);
                                        setLocalFilterActive(false);
                                    });
                                } else {
                                    setRowData(e.selectedRow);
                                    setIsAddFoodCourtClicked(true);
                                    setLocalFilterActive(false);
                                }
                            }}
                            height={25}
                            width={25}
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "pointer__clz cmn_icn_FRedit",
                                "ml-3"
                            )}`}
                        />
                    </div>
                </Tooltip>
                <Tooltip title={t("To configure")}>
                    <div>
                        <SettingsIcon
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setRowData(e.selectedRow);
                                        setIsModalOpened(true);
                                        setIsAddFoodCourtClicked(false);
                                        setLocalFilterActive(false);
                                    });
                                } else {
                                    setRowData(e.selectedRow);
                                    setIsAddFoodCourtClicked(false);
                                    setIsModalOpened(true);
                                    setLocalFilterActive(false);
                                }
                            }}
                            height={25}
                            width={25}
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "pointer__clz cmn_icn_FRedit",
                                "ml-3"
                            )}`}
                        />
                    </div>
                </Tooltip>
                <Tooltip
                    title={
                        e.selectedRow.state ? t("Unactivate") : t("Activate")
                    }
                >
                    <div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={e.selectedRow.state}
                            onChange={handleOpenClose}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                            className={`${classnames(
                                "pointer__clz cmn_icn_FRedit",
                                "ml-3"
                            )}`}
                        />
                    </div>
                </Tooltip>
            </div>
        </React.Fragment>
    );
}
